// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

/**
 * It's a necessary style that we need for all projects
 */
export const xSwiperStyle = css`
    width: 100%;
    .swiper-slide {
        // to make all slides has the same height
        height: auto;
        // To fix swiper render issue
        margin-top: 1px;
        margin-bottom: 1px;
        position: relative;
    }

    // hide swiper arrow navigation and use custom arrow navigation
    .swiper-button-prev,
    .swiper-button-next {
        display: none;
    }

    // override .swiper-pagination-bullets styles
    .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: initial;
        top: initial;
        left: initial;
        width: initial;
    }
    &&& .swiper-lazy-preloader {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${color("common.black", 0.33)};
        border: 0;
        animation: unset;
        border: unset;
        border-radius: 2px;
        margin: 0;
        // for now lazy loaded it but don't show loader
        display: none;
        &::after {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            display: block;
            transform: translate(-50%, -50%);
            animation: swiper-preloader-spin 1s infinite linear;
            width: 40px;
            height: 40px;
            z-index: 10;
            border-radius: 50%;
            border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
            border-top-color: transparent;
        }
    }
`;

export const xSwiperStickyDots = css`
    .xng-pagination-container {
        box-sizing: content-box;
        background: ${color("common.black", 0.5)};
        position: absolute;
        z-index: 10;
        bottom: 1px;
        left: 50%;
        transform: translate(-50%, 0);
        padding: 6px 16px;
        margin: 0;
        border-radius: 8px 8px 0px 0px;
        .swiper-pagination .swiper-pagination-bullet {
            background: transparent;
            border-color: ${color("common.white")};
            &:hover:not(.swiper-pagination-bullet-active) {
                background: ${color("common.white", 0.9)};
            }
        }
        .swiper-pagination .swiper-pagination-bullet-active {
            background: ${color("common.white")};
        }
        .carousel-left-icon,
        .carousel-right-icon {
            color: ${color("common.white")};
            &:not(.disabled):hover {
                color: ${color("common.white")};
            }
            &.disabled {
                color: ${color("common.white", 0.33)};
            }
        }
    }
`;

const shadowEl = css`
    content: "";
    position: absolute;
    display: block;
    height: calc(100% - 8px);
    width: ${({ shadowWidth }: any) => shadowWidth || "24px"};
    background: linear-gradient(270deg, #fff 0%, #fff0 100%);
    background: linear-gradient(270deg, ${color("common.white", 1)} 0%, ${color("common.white", 0)} 100%);
    top: 0px;
    z-index: 2;
`;
export const xSwiperShadow = css`
    ${xScreen("gt", "md")} {
        &.xng-swiper-with-shadow {
            &:has(.swiper-button-next:not(.swiper-button-disabled)) {
                .swiper-horizontal::after {
                    ${shadowEl}
                    right: 0px;
                }
            }
            &:has(.swiper-button-prev:not(.swiper-button-disabled)) {
                .swiper-horizontal::before {
                    ${shadowEl}
                    left: 0px;
                    background: linear-gradient(
                        90deg,
                        ${color("common.white", 1)} 0%,
                        ${color("common.white", 0)} 100%
                    );
                }
            }
        }
    }
`;
